import React from 'react'
import { useRive } from '@rive-app/react-canvas'

export default function RiveButton({
  src,
  className = '',
  onClick,
  width = 100,
  height = 60,
}) {
  const { rive, RiveComponent } = useRive({
    src: src,
    autoplay: true,
    stateMachines: 'State Machine 1', // Default state machine name
    onLoad: () => {
      console.log('Rive animation loaded')
    },
    onLoadError: (error) => {
      console.error('Failed to load Rive animation:', error)
    },
  })

  const handleClick = () => {
    // Trigger hover/click state in Rive animation if available
    if (rive) {
      const inputs = rive.stateMachineInputs('State Machine 1')
      const clickInput = inputs?.find((input) => input.name === 'Click' || input.name === 'click')
      if (clickInput) {
        clickInput.fire()
      }
    }
    onClick?.()
  }

  const handleMouseEnter = () => {
    // Trigger hover state in Rive animation if available
    if (rive) {
      const inputs = rive.stateMachineInputs('State Machine 1')
      const hoverInput = inputs?.find((input) => input.name === 'Hover' || input.name === 'hover')
      if (hoverInput) {
        hoverInput.value = true
      }
    }
  }

  const handleMouseLeave = () => {
    // Remove hover state in Rive animation if available
    if (rive) {
      const inputs = rive.stateMachineInputs('State Machine 1')
      const hoverInput = inputs?.find((input) => input.name === 'Hover' || input.name === 'hover')
      if (hoverInput) {
        hoverInput.value = false
      }
    }
  }

  return (
    <div
      className={`cursor-pointer ${className}`}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ width, height }}
    >
      <RiveComponent style={{ width: '100%', height: '100%' }} />
    </div>
  )
}

// Fallback component when Rive file is not available
export function RiveFallbackButton({ onClick, className = '' }) {
  return (
    <button
      onClick={onClick}
      className={`relative px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-medium rounded-full hover:scale-105 transition-all duration-300 ease-out shadow-lg hover:shadow-xl ${className}`}
    >
      <span className="relative z-10">📅 Book a Call</span>
      <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
    </button>
  )
}
